import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import PushPinIcon from "@mui/icons-material/PushPin";
import {
  Box,
  createTheme,
  Divider,
  IconButton,
  Stack,
  Theme,
  ThemeProvider,
  Typography,
  useTheme,
} from "@mui/material";
import { observer } from "mobx-react";
import * as React from "react";
import { useApplicationContext } from "src/pi/application/ApplicationContext";
import TopMenuComponent from "./app/TopMenuComponent";
import { NotificationMenu } from "./NotificationMenu";
import App from "src/pi/application/App";

interface IProps {
  onlyTempMenu: boolean;
  onReload(): void;
  isMenuPermanent: boolean;
  togglePermanent(): void;
  handleDrawerToggle(): void;
}

const DrawerComponent: React.FC<IProps> = observer((props) => {
  const {
    onlyTempMenu,
    onReload,
    isMenuPermanent,
    togglePermanent,
    handleDrawerToggle,
  } = props;

  const appContext = useApplicationContext();
  const { user } = appContext || {};

  const theme = useTheme();

  const onProfile = () => {
    App().selectPageAsync("page:/Profile");
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        height: "100%",
      }}
      className="drawer-component"
    >
      <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
        <Box
          style={{
            height: "64px",
            // paddingTop: "12px",
            // paddingBottom: "12px",
            width: onlyTempMenu ? "100%" : "calc(100% - 40px)",
            // background: "#eee",
            background: theme.palette.primary.main,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onDoubleClick={onReload}
          >
            <img
              src="https://links.fci.cloud/logo.png"
              height="48"
              style={{ paddingTop: 6, paddingBottom: 6 }}
              alt=""
            />
            <span
              style={{
                fontSize: "8pt",
                color: theme.palette.primary.contrastText,
              }}
            >
              {import.meta.env.VITE_VERSION}
            </span>
          </div>
        </Box>
        {!onlyTempMenu && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "center",
              width: 40,
              background: theme.palette.primary.main,
            }}
          >
            {isMenuPermanent ? (
              <IconButton
                onClick={handleDrawerToggle}
                sx={{ color: theme.palette.primary.contrastText }}
              >
                <ChevronLeftIcon />
              </IconButton>
            ) : (
              <IconButton
                onClick={togglePermanent}
                sx={{ color: theme.palette.primary.contrastText }}
              >
                <PushPinIcon />
              </IconButton>
            )}
          </div>
        )}
      </div>
      <Box
        style={{
          overflowY: "auto",
          overflowX: "hidden",
          flex: 1,
          minHeight: 0,
        }}
      >
        <ThemeProvider
          theme={(outerTheme: Theme) =>
            createTheme(outerTheme, {
              components: {
                MuiMenuItem: {
                  styleOverrides: {
                    root: {
                      color: outerTheme.palette.primary.contrastText,
                      "&:hover": {
                        backgroundColor: outerTheme.palette.action.hover,
                      },
                      "&.Mui-selected": {
                        backgroundColor:
                          outerTheme.palette.primary.contrastText,
                        color: outerTheme.palette.primary.dark,
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor:
                          outerTheme.palette.primary.contrastText,
                        color: outerTheme.palette.primary.main,
                      },
                    },
                  },
                },
                MuiListItemIcon: {
                  styleOverrides: {
                    root: {
                      color: "inherit",
                    },
                  },
                },
              },
            })
          }
        >
          <TopMenuComponent />
        </ThemeProvider>
      </Box>
      <Divider />
      <div style={{ background: "#222", flexShrink: 0 }}>
        <Stack direction={"row"} alignItems={"center"} padding={1} spacing={1}>
          <NotificationMenu />
          <div style={{ padding: 4, cursor: "pointer" }} onClick={onProfile}>
            <Stack minWidth={0} overflow="hidden">
              <Typography color="#777" fontWeight={"bold"} noWrap>
                {user?.name}
              </Typography>
              <Typography color="#777" noWrap>
                {user?.email}
              </Typography>
            </Stack>
          </div>
        </Stack>
      </div>
    </Box>
  );
});

export default DrawerComponent;
